// src/components/XPopup.js
import React from "react";
import "./XPopup.css";

/**
 * XPopup — popup mínimo para alert/confirm, com classes prefixadas (xpop-*)
 * tipo: "info" | "confirm"
 */
export default function XPopup({ open, tipo = "info", mensagem, onClose, onConfirm }) {
  if (!open) return null;

  return (
    <div className="xpop-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div
        className={`xpop-box xpop-${tipo}`}
        onClick={(e) => e.stopPropagation()}
      >
        <p className="xpop-msg">{mensagem}</p>

        <div className="xpop-actions">
          {tipo === "confirm" ? (
            <>
              <button className="xpop-btn xpop-btn-ok" onClick={onConfirm}>Confirmar</button>
              <button className="xpop-btn xpop-btn-cancel" onClick={onClose}>Cancelar</button>
            </>
          ) : (
            <button className="xpop-btn xpop-btn-ok" onClick={onClose}>OK</button>
          )}
        </div>
      </div>
    </div>
  );
}
